const LIMIT = 1024 * 1024;

const toBlob = (canvas, quality) => new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));

const loadBitmap = async (file) => {
  try {
    return await createImageBitmap(file, { imageOrientation: "from-image" });
  } catch {
    const url = URL.createObjectURL(file);
    try {
      const img = new Image();
      img.src = url;
      await img.decode();
      return img;
    } finally {
      URL.revokeObjectURL(url);
    }
  }
};

// 1MBを超える写真をJPEGに変換して1MB以下にする
export async function compressImage(file, limit = LIMIT) {
  if (!file || file.size <= limit || !file.type.startsWith("image/")) return file;
  try {
    return await shrink(file, limit);
  } catch {
    return file;
  }
}

async function shrink(file, limit) {
  const source = await loadBitmap(file);
  const w0 = source.width;
  const h0 = source.height;
  let scale = Math.min(1, 2560 / Math.max(w0, h0));
  const canvas = document.createElement("canvas");
  for (let round = 0; round < 8; round += 1) {
    canvas.width = Math.round(w0 * scale);
    canvas.height = Math.round(h0 * scale);
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(source, 0, 0, canvas.width, canvas.height);
    for (const q of [0.85, 0.75, 0.65, 0.55]) {
      const blob = await toBlob(canvas, q);
      if (blob && blob.size <= limit) {
        source.close?.();
        const name = file.name.replace(/\.[^.]+$/, "") + ".jpg";
        return new File([blob], name, { type: "image/jpeg", lastModified: Date.now() });
      }
    }
    scale *= 0.75;
  }
  source.close?.();
  throw new Error("compress_failed");
}
